import styled from 'styled-components';
import { GhostButton } from '../buttons';
import { SearchInput } from '../input';
import { ZTooltip } from '../ztooltip';

export const SidebarContainer = styled.div<{ position: string; $isMainSidebar?: boolean; $isDialog?: boolean }>`
    position: ${(props) => (props.$isDialog ? 'static' : props.position)};
    width: ${(props) => (props.$isDialog ? '100%' : '300px')};
    height: ${(props) => (props.$isDialog ? '100%' : `calc(100% - ${props.position === 'fixed' ? (props.$isMainSidebar ? '56px' : '118px') : '58px'})`)};
    background-color: transparent;
    padding: 20px 0px;
    overflow: auto;
    top: 0;
    left: 0;
`;

export const SidebarButtons = styled.div`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    margin-left: auto;
`;

export const SidebarButtonStyle = styled(GhostButton).attrs({
    $size: 'small',
    type: 'button'
})`
    margin-left: 5px;
    min-width: ${(props) => props.theme.app.component.button.small.height};
    width: ${(props) => props.theme.app.component.button.small.height};
    padding: 0;
    gap: 0;
`;

export const TooltipCategories = styled(ZTooltip)`
    max-width: max-content;
`;

export const StyledSpan = styled.span<{ maxWidth?: string }>`
    max-width: ${(props) => props.maxWidth || 'max-content'};
`;

export const SidebarListItem = styled.div<{ $selected?: boolean; disabled?: boolean; $indent?: boolean }>`
    display: flex;
    align-items: center;
    padding: 6px 9px 6px ${(props) => (props.$indent !== false ? '25px' : '0')};
    margin-bottom: 4px;
    cursor: pointer;
    flex-wrap: nowrap;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    transition: all 0.2s ease;
    background: ${(props) => (props.$selected ? 'rgb(0 0 0 / 5%)' : 'transparent')};
    border-radius: ${(props) => (props.$selected ? '8px' : 'unset')};

    span {
        box-sizing: border-box;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1;
        min-width: 0;
    }

    ${(props) =>
        !props.disabled &&
        `
    &:hover {
        background: rgb(0 0 0 / 5%);
        border-radius: 8px;
    }`}

    ${(props) =>
        props.disabled &&
        `
    color: #BBB;
    `}
`;

export const SidebarHeaderContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 0 0 12px 0;
    position: relative;
`;

export const SidebarHeader = styled.h1`
    margin: 0;
    flex: 1;
    font-size: 14px;
    font-weight: 600;
    color: #263238;
`;

export const SidebarSearchInput = styled(SearchInput)`
    padding: 5px;
    font-size: 10px;
    width: 100%;
    flex: 1;
    height: 30px;
`;
